export function formatLabel(str) {
  if (!str) return "";
  return str
    .replace(/_/g, " ") // replace underscores with spaces
    .replace(/\b\w/g, (char) => char.toUpperCase()); // capitalize first letters
}
